import type { CarouselHeadlineProps } from "./types";

const HEADLINE_CLASS =
  "text-center text-[26px] font-medium leading-[1.2] text-emphasis lg:text-[36px]";

/**
 * Molecule: the centered h2 above a product carousel, shared by
 * ProductCarousel and productRecommendations' "headline" heading style
 * (COM-426), so both draw the same headline.
 */
export function CarouselHeadline({
  children,
  className,
}: CarouselHeadlineProps) {
  return (
    <h2
      className={className ? `${className} ${HEADLINE_CLASS}` : HEADLINE_CLASS}
    >
      {children}
    </h2>
  );
}
